module.exports = __webpack_public_path__ + "img/enabing-skills.f86e9c2c.png";